// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"136":"739d0696","235":"9dc3e765","237":"43ff7641"}[chunkId] + ".js";
};